import React from 'react';
import { Navigate } from 'react-router-dom';

const AdminProtectedRoute = ({ children }) => {
  const isAdminAuthenticated = localStorage.getItem('isAdminAuthenticated') === 'true';
  const adminUser = JSON.parse(localStorage.getItem('adminUser') || '{}');
  
  // Check if user is authenticated AND has admin role
  if (!isAdminAuthenticated || adminUser.role !== 'admin') {
    return <Navigate to="/admin-login" replace />;
  }
  
  return children;
};

export default AdminProtectedRoute;